export const CartPayload=(product,quantity)=>{
    const payload={
        "AWS_CLASSIFICATION": product?.AWS_CLASSIFICATION,
        "CATEGORY_ID": String(product?.CATEGORY_ID),
        "CONCATENATED_SEGMENTS": product?.CONCATENATED_SEGMENTS,
        "CURRENCY_CODE": product?.CURRENCY_CODE,
        "DELIVERY_LEAD_TIME": product?.DELIVERY_LEAD_TIME,
        "DESCRIPTION": product?.DESCRIPTION,
        "DIAMETER": product?.DIAMETER,
        "IMAGE_NAME": product?.IMAGE_NAME,
        "INVENTORY_ITEM_ID": String(product?.INVENTORY_ITEM_ID),
        "INVENTORY_ITEM_STATUS_CODE": product?.INVENTORY_ITEM_STATUS_CODE,
        "LENGTH": product?.LENGTH,
        "LIST_PRICE": String(Number(product?.LIST_PRICE).toFixed(2)),
        "MAIN_CATEGORY":product?.MAIN_CATEGORY ,
        "METHOD_OF_PACKING": product?.METHOD_OF_PACKING,
        "MINIMUM_ORDER_QUANTITY": product?.MINIMUM_ORDER_QUANTITY,
        "MODEL_DESCRIPTION": product?.MODEL_DESCRIPTION,
        "PACKING_SIZE": product.PACKING_SIZE===null?1:product.PACKING_SIZE,
        "PRIMARY_UOM_CODE": product?.PRIMARY_UOM_CODE,
        "STOCK_ONHAND_QTY": product?.STOCK_ONHAND_QTY,
        "quantity":Number(quantity),
        "discount_type":product.discount_type,
        "discount":product.discount ,
        "total_price": product.total_price,
        "discount_applied": product.discount_applied,
        "criteria": product.criteria,
        "deal":product.deal,
        "SHIPPING_ADDRESS": product.SHIPPING_ADDRESS,
        "BILLING_ADDRESS": product.BILLING_ADDRESS,
        "DAP": product.DAP,
        "additinal_discount":product.additinal_discount ,
        "trade_discount": product.trade_discount,
        "trade_discount_applied": product.trade_discount_applied,
        "additinal_discount_applied":product.additinal_discount_applied,
        "sub_total":product.sub_total,
        "offer_type":product.offer_type        
    }
    if(product.item_id !== undefined){
        payload['item_id']  = product.item_id
    }
    return payload
}